// extracted by mini-css-extract-plugin
export default {"addOnItem":"_0Vf8elFs54vnKngAPCcL","addOnButton":"_1_Y00oi9g6Wtv0n9aD3Jg-","icon":"_1me16BMz3Oi3Vm-3SQ5u3h"};